import { useDispatch } from 'react-redux';
import { enqueueSnackbar } from '../store/slices/notificationSlice';

export const useNotification = () => {
  const dispatch = useDispatch();

  const showNotification = (
    message: string,
    severity: 'success' | 'info' | 'warning' | 'error' = 'info',
    autoHideDuration?: number
  ) => {
    dispatch(
      enqueueSnackbar({
        message,
        severity,
        autoHideDuration,
      })
    );
  };

  const showSuccess = (message: string, autoHideDuration?: number) => {
    showNotification(message, 'success', autoHideDuration);
  };

  const showError = (message: string, autoHideDuration?: number) => {
    showNotification(message, 'error', autoHideDuration);
  };

  const showInfo = (message: string, autoHideDuration?: number) => {
    showNotification(message, 'info', autoHideDuration);
  };

  const showWarning = (message: string, autoHideDuration?: number) => {
    showNotification(message, 'warning', autoHideDuration);
  };

  return {
    showNotification,
    showSuccess,
    showError,
    showInfo,
    showWarning,
  };
};

export default useNotification; 